export default "__VITE_ASSET__CvPAZxwt__"